/**
 * Utilitaires
 */

/**
 * Affiche une boite de dialogue de type Oui-Non
 *
 * @param {string} msg
 * @param {string} title
 * @param {string} callBackOui Fonction à executer si l'utilisateur clique le bouton valider
 * @param {string} callBackNon Fonction à executer si l'utilisateur clique le bouton non
 */
function modalOuiNon(msg, title, callBackOui, callBackNon)
{
    if (! title) {
        title = 'Confirmer';
    }
    $('#modalOuiNonTitle').text(title);
    $('#modal-ouinon .modal-body').html(msg);
    $('#modal-ouinon').modal();

    $('#modal-ouinon .btn-primary').off().click(function() {
        if (callBackOui) {
            callBackOui();
        }
        $('#modal-ouinon').modal('hide');
    });

    if (callBackNon) {
        $('#modal-ouinon .btn-secondary').off().click(function() {
            callBackNon();
        });
    }
}

function modalOuiNonV2(msg, title, callBackOui, callBackNon)
{
    if (! title) {
        title = 'Confirmer';
    }
    $('#modalOuiNonTitleV2').text(title);
    $('#modal-ouinonV2 .modal-body').html(msg);
    $('#modal-ouinonV2 .btn-validate-modal-oui-non').show();
    $('#modal-ouinonV2 .btn-validate-modal-oui-non-spinner').hide();
    $('#modal-ouinonV2').modal();

    $('#modal-ouinonV2 .btn-primary').off().click(function() {
        if (callBackOui) {
            callBackOui({
                start:
                       function() {
                        $('#modal-ouinonV2 .btn-validate-modal-oui-non, ' +
                            '#modal-ouinonV2 .btn-cancel-modal-oui-non').hide();

                        $('#modal-ouinonV2 .btn-validate-modal-oui-non-spinner').show();
                    },
                stop:
                    function() {
                        $('#modal-ouinonV2').modal('hide');
                        $('#modal-ouinonV2 .btn-validate-modal-oui-non, ' +
                            '#modal-ouinonV2 .btn-cancel-modal-oui-non').show();
                        $('#modal-ouinonV2 .btn-validate-modal-oui-non-spinner').hide();
                    }
            });


        }

    });

    if (callBackNon) {
        $('#modal-ouinonV2 .btn-secondary').off().click(function() {
            callBackNon();
        });
    }
}

/**
 * Affiche l'erreur dans une modale
 *
 * @param {string} msg
 * @param {string} title
 */
function displayErrorMessage(msg, title)
{
    if (! title) {
        title = 'Erreur';
    }
    $('#modal-error .modal-body').html(msg);
    $('#modal-error').modal();
    $('#modal-error #modalErrorTitle').text(title);

    $('#modal-error .btn-primary').click(function() {
        $('#modal-error').modal('hide');
    });
}


/**
 * Insère un spinner sur le boutton valider sur le formulaire
 *
 * @param {string} formId
 * @param {string} textBtn
 */
function addSpinnerOnSubmitBtn(formId, textBtn)
{
    if (! textBtn) {
        textBtn = 'Envoi ...';
    }
    $('#' + formId + ' button[type="submit"]').attr('disabled', true).html(
        '<span class="spinner-border spinner-border" role="status" aria-hidden="true"></span> ' + textBtn
    );
}

/**
 * Supprime le spinner du boutton 'Valider du formulaire
 *
 * @param {string} formId
 * @param {string} textBtn
 */
function removeSpinnerOnSubmitBtn(formId, textBtn)
{
    if (! textBtn) {
        textBtn = 'Valider';
    }
    $('#' + formId + ' button[type="submit"]').attr('disabled', false).text(textBtn);
}

/**
 * Insère un spinner sur le boutton
 *
 * @param {string} jQuerySelector
 * @param {string} textBtn
 */
function addSpinnerOnBtn(jQuerySelector, textBtn)
{
    if (! textBtn) {
        textBtn = 'Envoi ...';
    }
    $(jQuerySelector).attr('disabled', true).html(
        '<span class="spinner-border spinner-border" role="status" aria-hidden="true"></span> ' + textBtn
    );
}

/**
 * Supprime le spinner du boutton
 *
 * @param {string} jQuerySelector
 * @param {string} textBtn
 */
function removeSpinnerOnBtn(jQuerySelector, textBtn)
{
    if (! textBtn) {
        textBtn = 'Valider';
    }
    $(jQuerySelector).attr('disabled', false).text(textBtn);
}

/**
 * Insère un retour à la ligne HTML à chaque nouvelle ligne
 *
 * @param {string}  str      La chaîne d'entrée.
 * @param {boolean} is_xhtml Produit des césures compatibles XHTML ou non.
 *
 * @returns {string} Retourne la chaîne modifiée.
 */
function nl2br (str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
}

var Util = {

    initAjaxCsrfProtection: function() {
        var $inputCsrf = $('input.csrf-protection');

        $.ajaxPrefilter(function(options, originalOptions) {
            if (options.type.toUpperCase() === 'POST') {
                if ($inputCsrf.length) {
                    if (originalOptions.data instanceof FormData) {
                        options.data.set($inputCsrf.attr('name'), $inputCsrf.val());
                    } else {
                        options.data += '&' + $inputCsrf.attr('name') + "=" + $inputCsrf.val();
                    }
                }
            }
        });

        $(document).ajaxSuccess(function(event, jqXHR, settings) {
            if (settings.type.toUpperCase() === 'POST') {
                if (jqXHR.responseJSON && jqXHR.responseJSON.csrfTokenValue) {
                    $inputCsrf.val(jqXHR.responseJSON.csrfTokenValue);
                }
            }
        });

        $(document).ajaxError(function() {
            Util.getCsrf();
        });
    },

    getCsrf: function() {
        return $.get('/ajax/getCsrf', null, function(response) {
            var $csrfInput = $('input.csrf-protection');
            if ($csrfInput.length) {
                $('input.csrf-protection').val(response.token);
            }
        }, 'json');
    },

    /**
     * Affiche une boîte de dialogue, éventuellement avec un message, qui invite l'utilisateur à saisir un texte.
     *
     * @param {string} message Une chaîne de caractères qui sera affichée pour l'utilisateur
     * @param {string} default (facultatif) Une chaîne de caractères contenant la valeur par défaut affichée pour la saisie.
     * @param {string} title   (facultatif) Une chaîne de caractères qui sera affichée pour l'utilisateur
     * @param {string} callBackValidate (facultatif) Fonction à executer si l'utilisateur clique le bouton valider
     */
    modalPrompt: function(message, value, title, callBackValidate) {
        if (value === undefined || value === null) {
            value = '';
        }

        if (title === undefined || title === null) {
            title = '';
        }

        var $modal = $(
            '<div class="modal fade" id="modal-ouinon" tabindex="-1" role="dialog" aria-hidden="true">' +
                '<div class="modal-dialog" role="document">' +
                    '<div class="modal-content">' +
                        '<div class="modal-header">' +
                            '<h5 class="modal-title" id="modalOuiNonTitle">' + title + '</h5>' +
                            '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                                '<span aria-hidden="true">&times;</span>' +
                            '</button>' +
                        '</div>' +
                        '<form>' +
                            '<div class="modal-body">' +
                                '<div class="form-group">' +
                                    '<label for="note">' + message + '</label>' +
                                    '<input type="text" class="form-control" id="note" name="note" maxlength="255"' +
                                          ' value="' + value + '" required>' +
                                '</div>' +
                            '</div>' +
                            '<div class="modal-footer">' +
                                '<button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>' +
                                '<button type="submit" class="btn btn-primary btn-validate-note">Valider</button>' +
                            '</div>' +
                        '</form>' +
                    '</div>' +
                '</div>' +
            '</div>'
        );

        var $form = $modal.find('form');

        $form[0].reset();
        $modal.modal();

        $form.off().submit(function(evt) {
            evt.preventDefault();
            if (callBackValidate) {
                callBackValidate($form.find('input').val());
            }
            $modal.modal('hide');
        });

        $modal.on('hidden.bs.modal', function(e) {
            $modal.modal('dispose');
        });
    }
}

function debounce(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
};
